$(document).ready(function() {
    $('.slider-who-we-work').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        variableWidth: false,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });

    $('.customers-testimonials').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        variableWidth: false,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#pricelenght').on("change", function(event) {
        $(".lenght-controller td").removeClass('active');
        var pricelenght = '';
        if ($(this).is(":checked")) {
            pricelenght = 'annually';
        } else {
            pricelenght = 'monthly';
        }
        $(".lenght-" + pricelenght).addClass('active');
        displayPackagePrice(pricelenght, $('.currency:checked').val());
    });
    $('.currency').on("click", function(event) {
        var currency = '';
        var pricelenght = '';
        if ($('#pricelenght').is(":checked")) {
            pricelenght = 'annually';
        } else {
            pricelenght = 'monthly';
        }
        if ($(this).is(":checked")) {
            currency = $(this).val();
        }
        displayPackagePrice(pricelenght, currency);
    });
    $('.faqs-ul li').on("click", function(event) {
        $(this).toggleClass("active-faq");
        $(this).find('.faq-answers').toggle("slow");
    });
    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.rad-btn-toggle').click(function() {
        $('.form-popup-wrap').addClass('active');
    });

    $('.close-form').click(function() {
        $('.form-popup-wrap').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.testimonial-btn').click(function() {
        $('.item-testimonials').toggleClass('active');
        $(this).children('.more').toggleClass('active');
        $(this).children('.less').toggleClass('active');
    });
    if (typeof $(".section-widget-blog") != "undefined") {
        $(".section-widget-text h3").css("min-height", maxHeight($(".section-widget-text h3")));
        $(".section-widget-text .content").css("min-height", maxHeight($(".section-widget-text .content")));
    }
    if (typeof $(".customers-testimonials .item p.item-title") != "undefined") {
        $(".customers-testimonials .item p.item-title").css("min-height", maxHeight($(".customers-testimonials .item p.item-title")));
    }

});
var maxHeight = function(elems) {
    return Math.max.apply(null, elems.map(function() {
        return $(this).height();
    }).get());
}

function displayPackagePrice(pricelenght, currency) {
    $(".package-price, .package-button .primary-button").hide();
    $(".package-price." + pricelenght + "." + currency).show();
    $(".package-button .primary-button." + pricelenght + "." + currency).css("display", "block");
}